<template>
  <div class="tipo">
    <div class="centro">
      <h1>Consulta por Tipo de Veto</h1>
      <BuscaSimplesCards
        titulo="Consultas Rápidas"
        :cards="cardsMensagemVeto"
      />
      <Loading v-if="carregando" />
      <ErroResultados v-if="!carregando && erro" />
      <PainelBuscaSimplificada
        :dados="tiposFormatados"
        :generateUrl="generateUrl"
        titulo="Tipos de Veto"
        v-if="!carregando && !erro"
      />
    </div>
  </div>
</template>

<script>
import MensagemVetoApi from "../../services/MensagemVetoApi";
import Loading from "../../components/Loading";
import ErroResultados from "../../components/ErroResultados";
import PainelBuscaSimplificada from "../../components/PainelBuscaSimplificada";
import { mixinMensagemVeto } from "../../mixins/mixinMensagemVeto";
import metaDados from "../../helpers/metaDados";

export default {
  name: "PorTipoVetoMensagemVeto",
  metaInfo() {
    return {
      title: "Pesquisa de Mensagem de Veto por Tipo de Veto",
      titleTemplate: "%s - Casa Civil do Estado de Goiás",
      meta: [
        {
          vmid: "description",
          name: "description",
          property: "description",
          content:
            "Página de acesso e pesquisa a todos os Ofícios de Mensagem de Veto do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:description",
          property: "og:description",
          content:
            "Página de acesso e pesquisa a todos os Ofícios de Mensagem de Veto do Governo do Estado de Goiás.",
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            "Pesquisa de Mensagem de Veto por Tipo de Veto - Casa Civil do Estado de Goiás",
        },
        {
          vmid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          property: "twitter:description",
          content:
            "Página de acesso e pesquisa a todos os Ofícios de Mensagem de Veto do Governo do Estado de Goiás.",
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          property: "twitter:title",
          content:
            "Pesquisa de Mensagem de Veto por Tipo de Veto - Casa Civil do Estado de Goiás",
        },
        ...metaDados(this.$route),
      ],
    };
  },
  mixins: [mixinMensagemVeto],
  data() {
    return {
      carregando: true,
      erro: false,
      tipos: [],
      filtro: {
        tipo_veto: [],
        ano: null,
      },
    };
  },
  computed: {
    // Parte para formatar os números com separador milhar.
    tiposFormatados() {
      return this.tipos.map((tipo) => {
        return {
          ...tipo,
          quantidade: tipo.quantidade_total,
        };
      });
    },
  },
  components: {
    PainelBuscaSimplificada,
    Loading,
    ErroResultados,
  },
  created() {
    this.mensagemVetoApi = new MensagemVetoApi();

    this.carregarTipos();
  },
  methods: {
    carregarTipos: async function () {
      try {
        if (this.mensagemVetoApi.cancelTokens.getTiposVetoAgrupado) {
          this.mensagemVetoApi.cancelTokens.getTiposVetoAgrupado.cancel();
        }

        this.carregando = true;
        this.erro = false;
        this.tipos = await this.mensagemVetoApi.getTiposVetoAgrupado();
        this.carregando = false;
      } catch (err) {
        if (this.mensagemVetoApi.isCancel(err)) {
          return;
        }
        console.log(err);
        this.erro = true;
        this.carregando = false;
      }
    },
    generateUrl(ano, dados) {
      this.filtro.tipo_veto = dados.id;
      this.filtro.ano = ano;

      this.$router.push({
        name: "PesquisaMensagemVeto",
        query: {
          ...this.filtro,
          pagina: 1,
          qtd_por_pagina: this.qtd_por_pagina,
          busca_avancada: 1,
        },
      });
    },
    formatNumber(number) {
      // Método para formatar os números com separador milhar.
      return number.toLocaleString("pt-BR");
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  background-color: #ffb24e;
  width: fit-content;
  border-radius: 12px;
  color: #115810;
  font-size: 1.5rem;
  padding: 0 0.3rem;
  margin: 2rem 0rem 1.5rem 0.5rem;
}
.tipo {
  min-height: calc(100vh - 10rem);
  margin-bottom: 5rem;
}

p {
  text-indent: 1.5rem;
  margin: 1rem 1.5rem 1rem 0.5rem;
  font-size: 0.9rem;
  letter-spacing: 0.03rem;
  strong {
    text-transform: uppercase;
  }
}

.alto-contraste {
  p {
    color: white;
  }
}
</style>
